// Enter-view animation
const initEnterView = () => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('entered')
        entry.target.querySelectorAll('.animate__animated.opacity-0').forEach((el) => {
          el.classList.remove('opacity-0')
          el.classList.add(el.dataset.animateClass)
        })
      }
    })
  }, { threshold: 0, rootMargin: '0px 0px -200px 0px' })
  document.querySelectorAll('.enter-view').forEach((el) => observer.observe(el))
}

// Animated Counters
const initAnimatedCounters = () => {
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.querySelectorAll('.animated-counter').forEach(counter => {
          const speed = Number(counter.dataset.speed) * 1000
          const animate = () => {
            const value = +Number(counter.dataset.value)
            const data = +Number(counter.querySelector('em').textContent)
            const time = value / speed
            if (data < value) {
              counter.querySelector('em').textContent = Math.ceil(data + time)
              setTimeout(animate, 10)
            } else {
              counter.querySelector('em').textContent = value
            }
          }
          animate()
        })
      }
    })
  }, { threshold: 0.25 })
  document.querySelectorAll('.animated-counters').forEach((el) => observer.observe(el))
}

document.addEventListener('DOMContentLoaded', () => {
  initEnterView()
  initAnimatedCounters()
})
